// Widget Scripts
import adWidget from './js/widgets/adWidget';
import infoCards from './js/widgets/infoCards';
import mainFeature from './js/widgets/mainFeature';
import majorSponsors from './js/widgets/majorSponsors';
import mapButton from './js/widgets/mapButton';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';
import seoWidget from './js/widgets/seoWidget';
import sponsors from './js/widgets/sponsors';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    adWidget();
    infoCards();
    mainFeature();
    majorSponsors();
    mapButton();
    multiScheduleFeature();
    seoWidget();
    sponsors();
  });
}